import getApiClient from '../../../shared/api/api-client/getApiClient';

export default async function logOut(): Promise<void> {
  const client = getApiClient();

  await client.post('/api/user/logout');
}
